import {
    CLEAR,
    SET_IMPORT_DIALOG_ACTIVE,
    SET_IMPORT_DIALOG_CONFIRM,
    SET_IMPORT_DIALOG_DONE,
    SET_IMPORT_DIALOG_ERROR,
    SET_PROJECT_LIST,
    SET_PROJECT_SELECTED,
    FETCH_PROJECT_SPEC,
    FETCH_PROJECT_SPEC_START,
    FETCH_PROJECT_SPEC_SUCCESS,
    FETCH_PROJECT_SPEC_ERROR,
    FETCH_PROJECT_LIST,
    FETCH_PROJECT_LIST_START,
    FETCH_PROJECT_LIST_SUCCESS,
    FETCH_PROJECT_LIST_ERROR
} from './constants'

const clear = () => ({ type: CLEAR })
const setImportDialogActive = () => ({ type: SET_IMPORT_DIALOG_ACTIVE })
const setImportDialogConfirm = () => ({ type: SET_IMPORT_DIALOG_CONFIRM })
const setImportDialogDone = () => ({ type: SET_IMPORT_DIALOG_DONE })
const setImportDialogError = () => ({ type: SET_IMPORT_DIALOG_ERROR })
const setProjectList = (projectList) => ({ type: SET_PROJECT_LIST, projectList })
const setProjectSelected = (project) => ({ type: SET_PROJECT_SELECTED, project })

const fetchProjectSpec = (projectId) => ({ type: FETCH_PROJECT_SPEC, projectId })
const fetchProjectSpecStart = () => ({ type: FETCH_PROJECT_SPEC_START })
const fetchProjectSpecSuccess = () => ({ type: FETCH_PROJECT_SPEC_SUCCESS })
const fetchProjectSpecError = (error) => ({ type: FETCH_PROJECT_SPEC_ERROR, error})

const fetchProjectList = (query) => ({ type: FETCH_PROJECT_LIST, query })
const fetchProjectListStart = () => ({ type: FETCH_PROJECT_LIST_START })
const fetchProjectListSuccess = () => ({ type: FETCH_PROJECT_LIST_SUCCESS })
const fetchProjectListError = (error) => ({ type: FETCH_PROJECT_LIST_ERROR, error })

export {
    clear,
    setImportDialogActive,
    setImportDialogConfirm,
    setImportDialogDone,
    setImportDialogError,
    setProjectList,
    setProjectSelected,
    fetchProjectSpec,
    fetchProjectSpecStart,
    fetchProjectSpecSuccess,
    fetchProjectSpecError,
    fetchProjectList,
    fetchProjectListStart,
    fetchProjectListSuccess,
    fetchProjectListError
}